"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-ivano": {
    "651fefd8": [{
      "hkey": "ad62447a",
      "slug": "ivano-fracena",
      "name": "Ivano-Fracena",
      "primary": true,
      "skipSearch": false
    }],
    "fracena": [{
      "hkey": "ad62447a",
      "slug": "ivano-fracena",
      "name": "Ivano-Fracena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castel-ivano"
    }],
    "27c064ef": [{
      "hkey": "ad62447a",
      "slug": "ivano-fracena",
      "name": "Ivano-Fracena",
      "primary": true,
      "skipSearch": false
    }],
    "ivano": [{
      "hkey": "ad62447a",
      "slug": "ivano-fracena",
      "name": "Ivano-Fracena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castel-ivano"
    }]
  }
};
exports["default"] = _default;